<script setup lang="ts">
import type { Program, Settings } from '../types/general';
import ResultCard from './ResultCard.vue';

const props = defineProps<{
  results: Program[];
  settings: Settings;
  recomends: Program[];
}>();

const emit = defineEmits(['start-over']);
</script>

<template>
  <div class="program-result-step">
    <div
      v-if="!results.length"
      class="program-result-step__header"
    >
      <img
        class="text-center mb-30"
        src="/public/images/planet.svg"
        alt="icon"
      />
      <h2>{{ props.settings.no_result.message }}</h2>
      <div class="program-result-step__header__ctas">
        <button
          @click="emit('start-over')"
          type="button"
          class="btn outlined transparent wide"
        >
          Start Over
        </button>
        <a
          :href="props.settings.no_result.programs_url"
          class="btn wide"
          >Return to all programs</a
        >
      </div>
    </div>
    <div v-else>
      <div class="program-result-step__header">
        <img
          class="text-center mb-30"
          src="/public/images/fb-flag.svg"
          alt="icon"
        />
        <h2 class="mb-30">These programs match your criteria</h2>
      </div>

      <div class="program-results-grid">
        <ResultCard
          v-for="item in results"
          :key="item.nid"
          :card="item"
        />
      </div>
    </div>

    <div
      v-if="!results.length"
      class="program-result-step__recomends bg-royal-blue full-width"
    >
      <div class="container container-full-lg">
        <h2>{{ settings.no_result.cards_title }}</h2>
        <div class="program-results-grid">
          <div
            v-for="(card, index) in props.settings.no_result.cards"
            :key="card.link.url"
            class="blue-card"
          >
            <div>
              <img
                :src="`/themes/custom/irexrd/html/public/images/program-logo-${index}.svg`"
                alt="icon"
              />
            </div>
            <h4>{{ card.title }}</h4>
            <p class="text-s mt-0 mb-20">{{ card.description }}</p>
            <a
              :href="card.link.url"
              class="icon-hover-effect"
            >
              <span class="arrow-forward-icon sm white"></span>
              {{ card.link.title }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="results[0]?.us_citizen === '1'">
      <div
        v-if="props.recomends.length"
        class="program-result-step__recomends bg-royal-blue full-width"
      >
        <div class="container container-full-lg">
          <h2>{{ settings.us_success.random_programs_title }}</h2>
          <div class="program-results-grid">
            <ResultCard
              v-for="item in props.recomends.slice(0, 2)"
              :key="item.nid"
              :card="item"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="program-result-step__recomends bg-royal-blue full-width"
    >
      <div class="container container-full-lg">
        <h2 class="mb-0">{{ props.settings.non_us_success.questions.title }}</h2>
        <p class="text-m text-center text-white mb-40">{{ props.settings.non_us_success.questions.description }}</p>
        <div class="program-results-grid">
          <div
            v-for="card in props.settings.non_us_success.questions.cards"
            :key="card.link.url"
            class="explore-card explore-card--tile"
          >
            <h4>{{ card.title }}</h4>
            <a
              :href="card.link.url"
              class="icon-hover-effect"
            >
              <span class="arrow-forward-icon sm"></span>
              {{ card.link.title }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
